import React, { useState } from "react";
import MyMasterLayout from "../../../layouts/Mentor/MyMasterlayout";
import "./../../../assets/css/mentor/mentordashboard/Paymentreceived.css";

const PaymentReceived = () => {
  const [activeTab, setActiveTab] = useState("pending");
  const [selected, setSelected] = useState(null); // for detail modal
  const [actionDone, setActionDone] = useState({}); // { id: 'confirmed' | 'rejected' }
  const [rejectReason, setRejectReason] = useState("");
  const [showRejectBox, setShowRejectBox] = useState(false);

  // ── Sample pending payments (replace with API data) ──
  const [payments, setPayments] = useState([
    {
      id: 1,
      studentName: "Ahmed Raza",
      studentEmail: "ahmed@example.com",
      studentPhone: "0312-3456789",
      studentImage: "https://i.pravatar.cc/150?img=11",
      courseName: "Web Development Bootcamp",
      amount: "Rs. 35,000",
      method: "JazzCash",
      submittedAt: "Mar 25, 2026",
      proofImage:
        "https://placehold.co/400x300/e8f5e9/059669?text=Payment+Screenshot",
      status: "pending",
    },
    {
      id: 2,
      studentName: "Sana Malik",
      studentEmail: "sana@example.com",
      studentPhone: "0333-9876543",
      studentImage: "https://i.pravatar.cc/150?img=5",
      courseName: "React & Node.js Mastery",
      amount: "Rs. 28,000",
      method: "EasyPaisa",
      submittedAt: "Mar 26, 2026",
      proofImage:
        "https://placehold.co/400x300/e3f2fd/1565c0?text=Payment+Screenshot",
      status: "pending",
    },
    {
      id: 3,
      studentName: "Bilal Khan",
      studentEmail: "bilal@example.com",
      studentPhone: "0345-1122334",
      studentImage: "https://i.pravatar.cc/150?img=8",
      courseName: "Python & Data Science",
      amount: "Rs. 22,000",
      method: "Bank Transfer",
      submittedAt: "Mar 24, 2026",
      proofImage:
        "https://placehold.co/400x300/fce4ec/e91e63?text=Payment+Screenshot",
      status: "confirmed",
      confirmedAt: "Mar 24, 2026",
    },
    {
      id: 4,
      studentName: "Hira Baig",
      studentEmail: "hira@example.com",
      studentPhone: "0321-5544332",
      studentImage: "https://i.pravatar.cc/150?img=9",
      courseName: "Web Development Bootcamp",
      amount: "Rs. 35,000",
      method: "JazzCash",
      submittedAt: "Mar 23, 2026",
      proofImage:
        "https://placehold.co/400x300/fff3e0/e65100?text=Payment+Screenshot",
      status: "rejected",
      rejectReason: "Screenshot was unclear, amount did not match.",
      rejectedAt: "Mar 23, 2026",
    },
  ]);

  const pending = payments.filter((p) => p.status === "pending");
  const confirmed = payments.filter((p) => p.status === "confirmed");
  const rejected = payments.filter((p) => p.status === "rejected");

  const getList = () => {
    if (activeTab === "pending") return pending;
    if (activeTab === "confirmed") return confirmed;
    if (activeTab === "rejected") return rejected;
    return payments;
  };

  const handleConfirm = (id) => {
    setPayments((prev) =>
      prev.map((p) =>
        p.id === id
          ? {
              ...p,
              status: "confirmed",
              confirmedAt: new Date().toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }),
            }
          : p,
      ),
    );
    setSelected(null);
  };

  const handleReject = (id) => {
    if (!rejectReason.trim()) return;
    setPayments((prev) =>
      prev.map((p) =>
        p.id === id
          ? {
              ...p,
              status: "rejected",
              rejectReason,
              rejectedAt: new Date().toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }),
            }
          : p,
      ),
    );
    setSelected(null);
    setRejectReason("");
    setShowRejectBox(false);
  };

  const methodColor = (m) => {
    if (m === "JazzCash") return { bg: "#fce4ec", color: "#e91e63" };
    if (m === "EasyPaisa") return { bg: "#e8f5e9", color: "#2e7d32" };
    if (m === "Bank Transfer") return { bg: "#e3f2fd", color: "#1565c0" };
    return { bg: "#f3f4f6", color: "#374151" };
  };

  const tabs = [
    {
      key: "pending",
      label: "Pending",
      count: pending.length,
      icon: "bi-hourglass-split",
    },
    {
      key: "confirmed",
      label: "Confirmed",
      count: confirmed.length,
      icon: "bi-check-circle-fill",
    },
    {
      key: "rejected",
      label: "Rejected",
      count: rejected.length,
      icon: "bi-x-circle-fill",
    },
  ];

  const totalEarned = confirmed.reduce((sum, p) => {
    const num = parseInt(p.amount.replace(/\D/g, ""), 10);
    return sum + (isNaN(num) ? 0 : num);
  }, 0);

  return (
    <MyMasterLayout>
      <div className="pr-page">
        {/* ── STATS ROW ── */}
        <div className="pr-stats-row">
          <div className="pr-stat-card pr-stat-pending">
            <div className="pr-stat-icon">
              <i className="bi bi-hourglass-split"></i>
            </div>
            <div>
              <p className="pr-stat-num">{pending.length}</p>
              <p className="pr-stat-label">Pending Payments</p>
            </div>
          </div>
          <div className="pr-stat-card pr-stat-confirmed">
            <div className="pr-stat-icon">
              <i className="bi bi-check-circle-fill"></i>
            </div>
            <div>
              <p className="pr-stat-num">{confirmed.length}</p>
              <p className="pr-stat-label">Confirmed</p>
            </div>
          </div>
          <div className="pr-stat-card pr-stat-rejected">
            <div className="pr-stat-icon">
              <i className="bi bi-x-circle-fill"></i>
            </div>
            <div>
              <p className="pr-stat-num">{rejected.length}</p>
              <p className="pr-stat-label">Rejected</p>
            </div>
          </div>
          <div className="pr-stat-card pr-stat-earned">
            <div className="pr-stat-icon">
              <i className="bi bi-cash-stack"></i>
            </div>
            <div>
              <p className="pr-stat-num">Rs. {totalEarned.toLocaleString()}</p>
              <p className="pr-stat-label">Total Earned</p>
            </div>
          </div>
        </div>

        {/* ── MAIN CARD ── */}
        <div className="ms-card">
          {/* Tab Bar */}
          <div className="ms-tab-bar">
            <div className="ms-tabs">
              {tabs.map((t) => (
                <button
                  key={t.key}
                  className={`ms-tab-btn ${activeTab === t.key ? "ms-tab-active" : ""}`}
                  onClick={() => setActiveTab(t.key)}
                >
                  <i className={`bi ${t.icon}`}></i>
                  {t.label}
                  <span
                    className={`ms-tab-count ${activeTab === t.key ? "ms-tab-count-active" : ""}`}
                  >
                    {t.count}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* Table */}
          {getList().length === 0 ? (
            <div className="empty-state">
              <i className="bi bi-inbox pr-empty-icon"></i>
              <p className="empty-title">No {activeTab} payments</p>
              <p className="empty-subtitle">
                {activeTab === "pending"
                  ? "All payment proofs have been reviewed."
                  : `No ${activeTab} payments yet.`}
              </p>
            </div>
          ) : (
            <div className="ms-table-wrap">
              <table className="ms-table">
                <thead>
                  <tr
                    className={
                      activeTab === "pending"
                        ? "pr-thead-amber"
                        : activeTab === "confirmed"
                          ? "pr-thead-green"
                          : "pr-thead-red"
                    }
                  >
                    <th className="ms-th ms-th-left">Student</th>
                    <th className="ms-th ms-th-left">Course</th>
                    <th className="ms-th ms-th-center">Amount</th>
                    <th className="ms-th ms-th-center">Method</th>
                    <th className="ms-th ms-th-center">Submitted</th>
                    <th className="ms-th ms-th-center">Status</th>
                    <th className="ms-th ms-th-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {getList().map((p, idx) => {
                    const mc = methodColor(p.method);
                    return (
                      <tr
                        key={p.id}
                        className={`ms-tr ${idx % 2 === 0 ? "ms-tr-even" : "ms-tr-odd"} pr-tr`}
                      >
                        {/* Student */}
                        <td className="ms-td">
                          <div className="ms-student-cell">
                            <img
                              src={p.studentImage}
                              alt={p.studentName}
                              className="ms-avatar"
                            />
                            <div>
                              <div className="ms-student-name">
                                {p.studentName}
                              </div>
                              <div className="ms-student-id">
                                {p.studentEmail}
                              </div>
                            </div>
                          </div>
                        </td>

                        {/* Course */}
                        <td className="ms-td">
                          <span className="pr-course-name">{p.courseName}</span>
                        </td>

                        {/* Amount */}
                        <td className="ms-td ms-td-center">
                          <span className="pr-amount">{p.amount}</span>
                        </td>

                        {/* Method */}
                        <td className="ms-td ms-td-center">
                          <span
                            className="pr-method-badge"
                            style={{ background: mc.bg, color: mc.color }}
                          >
                            {p.method}
                          </span>
                        </td>

                        {/* Date */}
                        <td className="ms-td ms-td-center">
                          <span className="ms-date-text">{p.submittedAt}</span>
                        </td>

                        {/* Status */}
                        <td className="ms-td ms-td-center">
                          {p.status === "pending" && (
                            <span className="pr-status pr-status-pending">
                              ⏳ Pending
                            </span>
                          )}
                          {p.status === "confirmed" && (
                            <span className="pr-status pr-status-confirmed">
                              ✓ Confirmed
                            </span>
                          )}
                          {p.status === "rejected" && (
                            <span className="pr-status pr-status-rejected">
                              ✗ Rejected
                            </span>
                          )}
                        </td>

                        {/* Action */}
                        <td className="ms-td ms-td-center">
                          <button
                            className="pr-view-btn"
                            onClick={() => {
                              setSelected(p);
                              setShowRejectBox(false);
                              setRejectReason("");
                            }}
                          >
                            <i className="bi bi-eye-fill"></i> View
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* ════ DETAIL MODAL ════ */}
        {selected && (
          <div className="pr-modal-overlay" onClick={() => setSelected(null)}>
            <div className="pr-modal" onClick={(e) => e.stopPropagation()}>
              {/* Modal Header */}
              <div
                className={`pr-modal-header ${selected.status === "confirmed" ? "pr-mh-green" : selected.status === "rejected" ? "pr-mh-red" : "pr-mh-amber"}`}
              >
                <div className="pr-modal-header-left">
                  <div className="pr-modal-header-icon">💳</div>
                  <div>
                    <p className="pr-modal-title">Payment Details</p>
                    <p className="pr-modal-sub">{selected.courseName}</p>
                  </div>
                </div>
                <button
                  className="pr-modal-close"
                  onClick={() => setSelected(null)}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>

              {/* Modal Body */}
              <div className="pr-modal-body">
                {/* Student Info */}
                <div className="pr-modal-student">
                  <img
                    src={selected.studentImage}
                    alt={selected.studentName}
                    className="pr-modal-avatar"
                  />
                  <div>
                    <p className="pr-modal-sname">{selected.studentName}</p>
                    <p className="pr-modal-semail">{selected.studentEmail}</p>
                    <p className="pr-modal-sphone">
                      <i className="bi bi-telephone-fill"></i>{" "}
                      {selected.studentPhone}
                    </p>
                  </div>
                  {selected.status === "pending" && (
                    <span className="pr-status pr-status-pending ml-auto">
                      ⏳ Pending Review
                    </span>
                  )}
                  {selected.status === "confirmed" && (
                    <span className="pr-status pr-status-confirmed ml-auto">
                      ✓ Confirmed
                    </span>
                  )}
                  {selected.status === "rejected" && (
                    <span className="pr-status pr-status-rejected ml-auto">
                      ✗ Rejected
                    </span>
                  )}
                </div>

                {/* Payment Info Row */}
                <div className="pr-modal-info-row">
                  <div className="pr-modal-info-box">
                    <span className="pr-modal-info-label">Amount</span>
                    <span className="pr-modal-info-val pr-modal-amount">
                      {selected.amount}
                    </span>
                  </div>
                  <div className="pr-modal-info-box">
                    <span className="pr-modal-info-label">Method</span>
                    <span className="pr-modal-info-val">{selected.method}</span>
                  </div>
                  <div className="pr-modal-info-box">
                    <span className="pr-modal-info-label">Submitted On</span>
                    <span className="pr-modal-info-val">
                      {selected.submittedAt}
                    </span>
                  </div>
                  {selected.confirmedAt && (
                    <div className="pr-modal-info-box">
                      <span className="pr-modal-info-label">Confirmed On</span>
                      <span className="pr-modal-info-val">
                        {selected.confirmedAt}
                      </span>
                    </div>
                  )}
                  {selected.rejectedAt && (
                    <div className="pr-modal-info-box">
                      <span className="pr-modal-info-label">Rejected On</span>
                      <span className="pr-modal-info-val">
                        {selected.rejectedAt}
                      </span>
                    </div>
                  )}
                </div>

                {/* Rejection reason */}
                {selected.status === "rejected" && selected.rejectReason && (
                  <div className="pr-reject-notice">
                    <i className="bi bi-exclamation-triangle-fill"></i>
                    <div>
                      <p className="pr-reject-notice-title">Rejection Reason</p>
                      <p className="pr-reject-notice-text">
                        {selected.rejectReason}
                      </p>
                    </div>
                  </div>
                )}

                {/* Payment Proof Screenshot */}
                <div className="pr-proof-section">
                  <p className="pr-proof-title">📎 Payment Proof Screenshot</p>
                  <img
                    src={selected.proofImage}
                    alt="payment proof"
                    className="pr-proof-img"
                  />
                </div>

                {/* Reject reason input (only for pending) */}
                {selected.status === "pending" && showRejectBox && (
                  <div className="pr-reject-box">
                    <label className="pr-reject-label">
                      Reason for Rejection{" "}
                      <span style={{ color: "#e74c3c" }}>*</span>
                    </label>
                    <textarea
                      className="pr-reject-textarea"
                      rows={3}
                      placeholder="e.g. Screenshot is unclear, wrong amount sent, etc."
                      value={rejectReason}
                      onChange={(e) => setRejectReason(e.target.value)}
                    />
                  </div>
                )}
              </div>

              {/* Modal Footer — actions only for pending */}
              {selected.status === "pending" && (
                <div className="pr-modal-footer">
                  {!showRejectBox ? (
                    <>
                      <button
                        className="pr-reject-btn"
                        onClick={() => setShowRejectBox(true)}
                      >
                        <i className="bi bi-x-circle-fill"></i> Reject
                      </button>
                      <button
                        className="pr-confirm-btn"
                        onClick={() => handleConfirm(selected.id)}
                      >
                        <i className="bi bi-check-circle-fill"></i> Confirm
                        Payment & Enroll Student
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="pr-cancel-reject-btn"
                        onClick={() => {
                          setShowRejectBox(false);
                          setRejectReason("");
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="pr-submit-reject-btn"
                        onClick={() => handleReject(selected.id)}
                        disabled={!rejectReason.trim()}
                        style={{ opacity: rejectReason.trim() ? 1 : 0.5 }}
                      >
                        <i className="bi bi-send-fill"></i> Submit Rejection
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </MyMasterLayout>
  );
};

export default PaymentReceived;
